import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import OrderList from './OrderList'
import OrderDetail from './Details'
import ErrorFallBack from '@/layout/Error'

const Orders = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={<OrderList />}
        errorElement={<ErrorFallBack />}
      />
      <Route
        path="detail"
        element={<OrderDetail />}
        errorElement={<ErrorFallBack />}
      />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}

Orders.OrderDetail = OrderDetail

export default Orders
